import React, { useState, useEffect, useRef } from "react";
import logo_green from "../../img/logo_green.svg";
import { JoinFormCompany } from "./JoinFormCompany";
import { ArrowLeftOutlined } from "@ant-design/icons";
import gsap from "gsap";

//@ts-ignore
export interface IJoinFormProps {
  setSuccess: (val: boolean) => void;
  setForgot: (x: string) => void;
}

export const JoinForm = ({ setSuccess, setForgot }: IJoinFormProps) => {
  const [step, setStep] = useState(0);
  const [errors, setErrors] = useState([]);
  const [data, setData] = useState({
    name: "",
    phone: "",
    email: "",
    company: "",
    job_title: "",
    country: "",
  });

  const containerRef = useRef<HTMLDivElement>(null);

  const handleChange = (e: any) => {
    setData({ ...data, [e.target.name]: e.target.value });
  };

  useEffect(() => {
    if (containerRef.current) {
      gsap.fromTo(
        containerRef.current,
        { opacity: 0, x: -20 },
        { opacity: 1, x: 0, duration: 0.5, ease: "power2.out" }
      );
    }
  }, []);

  return (
    <div className="login_form_container_initial" ref={containerRef}>
      <div className="d-flex justify-content-between ">
        <div className="back_arrow_back_link">
          <div
            className="login_go_back"
            onClick={() => {
              setForgot("center");
            }}
          >
            <ArrowLeftOutlined
              onClick={() => {
                setForgot("center");
              }}
            ></ArrowLeftOutlined>{" "}
            <button className={"go_back_text"}>Go back</button>
          </div>
        </div>
        <div className="login_form_forgot_top login_form_forgot_top_join">
          <img src={logo_green} alt="logo Demco" className="login_form_logo" />
        </div>
      </div>

      <div>
        <h2 className="h2_subtitle_blue h2_subtitle_blue_join">Join DEMCO</h2>
        <p className="paragraphe">
          Please complete the information below to join us !{" "}
        </p>
        <form>
          <JoinFormCompany
            setStep={setStep}
            setSuccess={setSuccess}
            handleChange={handleChange}
            data={data}
            setErrors={setErrors}
            errors={errors}
            setForgot={(x: string) => setForgot(x)}
          />
        </form>
      </div>
    </div>
  );
};
